import React, {useContext, useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import useReducerOnChange from "../../hooks/ReducerOnChange";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components";
import {_MainContent, _PageTitle, _PageWrapper} from "../layout";
import { _Button } from "../components";
import {_Autocomplete, _DateField, _Select} from "../form/";
import useTable from "../../inar2/hooks/Table";
import {_RenewalPoliciesListTable} from "../components/RenewalPoliciesList/RenewalPoliciesListTable";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ChiamaWeb, { CChiamaWebParametri } from "../../ChiamaWeb";
import {AlertDialogContext} from "../providers/AlertDialogProvider";
import useToggle from "../../hooks/Toggle";
import {_RenewalActionDialog} from "../components/RenewalPoliciesList/ActionDialog";
import {DeleteEmptyParams} from "../helpers/Common";
import DescriptionIcon from "@material-ui/icons/Description";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import teal from "@material-ui/core/colors/teal";

interface IRouteParam {
    ID_TipoRamo?: string;
    ID_Anag?: string;
}

export const _RenewalPoliciesList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const { ID_Anag = "" } = useParams<IRouteParam>();
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({
        Polizza: "",
        ID_TipoRamo: "",
        ID_TipoProdotto: "",
        ID_TipoPolizzaStato: "",
        ID_AnagContraente: ID_Anag,
        ID_AnagPOS: "",
        ID_AnagBeneficiario: "",
        ID_TipiRicercaDate: "",
        DataDa: "",
        DataA: "",
        Scaduti:"",
        SoloTR: "1"
    });
    const { Data, Options, IsLoading } = useTable("/api/Renewals/Search", FormData);
    const [autoRefresh, setAutoRefresh] = useState(true);
    const [autoClick, setAutoClick] = useState(false);
    const [soloTR, setSoloTRClick] = useState(true);
    
    const {ShowDialog} = useContext(AlertDialogContext);
    const { open: openRenewAll, toggle: toggleRenewAll } = useToggle();
    
    useEffect(() => {
        if (!Glob.AzioneAbilitata("PolizzaController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }

        props.SetMenu({ ...Glob.GetMenu(), Main: "Home", ID_MenuMain: (props.match.params as any).ID_Anag ? 10 : 8 });
    }, []);

    useEffect(() => {
        setFormData({ Type: "OnChangeFromValue", Name: "ID_TipoProdotto", Value: "" });
    }, [FormData.ID_TipoRamo]);
    
    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const OnClickRenewAll = (): void => {
        toggleRenewAll();
    };

    const OnRenewAll = (): void => {
        const Param: CChiamaWebParametri = {
            Metodo: "POST",
            URL: `/api/Renewals/SearchAndRenew`,
            OnRis: () => {
                toggleRenewAll();
                Options.onRefresh();
                //IsLoading = false;
            },
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error),
            OnInvio: (sender: ChiamaWeb) => DeleteEmptyParams({ ...FormData })
        };
        new ChiamaWeb().Chiama(Param);
    };
    
    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={DescriptionIcon} Title="Rinnovi">
                    {Glob.AzioneAbilitata("PolizzaController", Glob.Scrittura) && (
                        <a href={`/api/Renewals/ExportToExcel?sessione=${Glob.GetSessione().Sessione}&parametri=${JSON.stringify(DeleteEmptyParams({ ...FormData }))}`} target="_blank">
                            <Tooltip title="Excel">
                                <IconButton size="small" aria-label="add">
                                    <InsertDriveFileIcon htmlColor={teal[400]} />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                </_PageTitle>
                <_MainContent>
                    <_RenewalActionDialog
                        Open={openRenewAll}
                        Title={"Confirm"}
                        Message={`Rinnovare le polizze?`}
                        OnCancel={toggleRenewAll}
                        OnConfirm={OnRenewAll}
                        OnClose={toggleRenewAll}
                    />
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    id="Polizza"
                                    label={Trad.Trad("Numero")}
                                    value={FormData.Polizza}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_Autocomplete
                                    SearchInput
                                    Value={FormData.ID_TipoRamo}
                                    Name="ID_TipoRamo"
                                    Label="Ramo"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Tipi/Tipo?tabella=TipiRami&campo=TipoRamo"
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_Autocomplete
                                    SearchInput
                                    Value={FormData.ID_TipoProdotto}
                                    Name="ID_TipoProdotto"
                                    Label="Prodotto"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url={`/api/Tipi/Tipo?tabella=TipiProdotti&campo=TipoProdotto&parametri=${FormData.ID_TipoRamo}`}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <_Select
                                    Value={FormData.ID_TipiRicercaDate || ""}
                                    Name="ID_TipiRicercaDate"
                                    Label="Data"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Options={(Data?.Tipi && Data.Tipi["TipiRicercaDate"]) || {}}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <_DateField Value={FormData.DataDa || ""} Name="DataDa" Label="Da" OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })} />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <_DateField Value={FormData.DataA || ""} Name="DataA" Label="A" OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })} />
                            </Grid>
                            
                            <Grid item xs={12} md={3}>
                                <_Autocomplete
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    Value={FormData.ID_AnagContraente}
                                    Name="ID_AnagContraente"
                                    Label="Contraente"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <_Autocomplete
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    Value={FormData.ID_AnagPOS}
                                    Name="ID_AnagPOS"
                                    Label="POS"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <_Autocomplete
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    Value={FormData.ID_AnagBeneficiario}
                                    Name="ID_AnagBeneficiario"
                                    Label="Beneficiario"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={soloTR}
                                            onChange={e => {
                                              if (e.currentTarget.checked)
                                              {
                                                  setFormData({ Type: "OnChangeFromValue", Name: "SoloTR", Value:"1" });
                                              }
                                              else {
                                                  setFormData({ Type: "OnChangeFromValue", Name: "SoloTR", Value:"" });
                                              }
                                              setSoloTRClick(e.currentTarget.checked);
                                            }}
                                        />
                                    }
                                    label={"Solo tacito rinnovo"}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={4}>
                            <Grid item md={2}>
                                <_Button
                                    Attivo={!IsLoading}
                                    Testo={Trad.Trad("Cerca")}
                                    OnClick={() => {
                                        setFormData({ Type: "OnChangeFromValue", Name: "Scaduti", Value:"" });
                                        Options.onChangePage(0);}
                                    }
                                />
                            </Grid>
                            <Grid item md={2}>
                                <_Button
                                    Attivo={!IsLoading}
                                    Testo={Trad.Trad("Cerca scaduti")}
                                    OnClick={() => {
                                        setFormData({ Type: "OnChangeFromValue", Name: "Scaduti", Value:"1" });
                                        Options.onChangePage(0);}
                                    }
                                />
                            </Grid>
                            <Grid item md={2}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={autoRefresh}
                                            onChange={e => {setAutoRefresh(e.currentTarget.checked)}}
                                        />
                                    }
                                    label={"Aggiornamento automatico"}
                                />
                            </Grid>
                            <Grid item md={2}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={autoClick}
                                            onChange={e => {setAutoClick(e.currentTarget.checked)}}
                                        />
                                    }
                                    label={"Passaggio automatico"}
                                />
                            </Grid>
                            <Grid item md={2}>
                                <_Button
                                    Attivo={!IsLoading}
                                    Testo={Trad.Trad("Rinnova")}
                                    OnClick={() => OnClickRenewAll()}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <_RenewalPoliciesListTable 
                        Data={Data} 
                        IsLoading={IsLoading} 
                        Options={Options}
                        AutoRefresh={autoRefresh}
                        AutoClick={autoClick}
                        OnRefresh={Options.onRefresh}
                    />
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/RenewalPoliciesList.tsx